import React from 'react';
import { Field } from 'react-final-form';
import { CheckboxProps } from './types';
import {
  StyledCheckbox,
  StyledCheckboxIcon,
  StyledCheckboxLabel,
  StyledCheckboxLabelText,
  StyledColorTag,
} from './styles';
import { IconTick } from '../../../../assets/svg/icons';

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  tagColor,
  disabled,
  ...props
}) => (
  <StyledCheckboxLabel
    {...{ disabled }}
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    <StyledCheckbox type='checkbox' {...{ disabled, ...props }} />

    <StyledCheckboxIcon>
      <IconTick />
    </StyledCheckboxIcon>

    <StyledCheckboxLabelText>
      {tagColor ? <StyledColorTag tagColor={tagColor} /> : null}
      {label}
    </StyledCheckboxLabelText>
  </StyledCheckboxLabel>
);

export const FormCheckbox: React.FC<CheckboxProps & { name: string }> = ({
  name,
  ...props
}) => (
  <Field type='checkbox' {...{ name }}>
    {({ input }) => <Checkbox {...props} {...input} />}
  </Field>
);

export default Checkbox;
